import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, DialogConfirm } from 'components'
import { toast } from 'react-toastify'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material'
import { cloneDeep } from 'lodash'

import { useSelector } from 'react-redux'
import { submitExtraAutoAnswer } from 'services/apiKYP'
import styles from './styles'

const initialValues = {
  related: false,
  occurrence_sumary: '',
  adopted_approaches: '',
  answer_type: 'negative_media',
}

const initialErrors = {
  occurrence_sumary: false,
}

function NegativeMediaForm(props) {
  const { questionData } = props

  const token = useSelector((state) => state.auth.access_token)
  const classes = styles()

  const [formState, setFormState] = useState(initialValues)
  const [formErrors, setFormErrors] = useState(initialErrors)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const handleValidate = () => {
    const errors = cloneDeep(initialErrors)
    Object.keys(errors).forEach((key) => {
      errors[key] = formState[key] === ''
    })
    setFormErrors(errors)
    return Object.keys(errors).every((key) => errors[key] === false)
  }

  const cleanForm = () => {
    setFormState(initialValues)
    setFormErrors(initialErrors)
  }

  const handleSubmit = async () => {
    if (handleValidate()) {
      setLoading(true)
      submitExtraAutoAnswer(token, questionData.uuid, formState)
        .then(() => {
          toast.success('Resposta enviada com sucesso.')
          cleanForm()
        })
        .catch(() => {
          toast.error('Erro ao enviar respostas, por favor tente novamente')
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      toast.error(
        'Há campos obrigatórios vazios. Verifique os campos preenchidos e tente novamente.',
      )
    }
  }

  const handleCleanAction = () => {
    setOpen(false)
    cleanForm()
  }

  const handleFieldChange = (event) => {
    const newFormState = cloneDeep(formState)
    const key = event.target.id
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const handleRadioChange = (event) => {
    const key = event.target.name
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value === 'yes'
    setFormState(newFormState)
  }

  const handleOpenConfirmCleaning = () => {
    setOpen(true)
  }

  const handleCloseConfirmCleaning = () => {
    setOpen(false)
  }

  return (
    <div className={classes.root}>
      <h2>Mídia negativa</h2>
      <div className={classes.formWrapper}>
        <FormControl>
          <FormLabel>
            Os fatos noticiados {' '}
            <a
              href={questionData.occurrence.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              nesta midia negativa
            </a>{' '}
            estão relacionados com você?
          </FormLabel>
          <RadioGroup
            row
            value={formState.related ? 'yes' : 'no'}
            name="related"
            onChange={handleRadioChange}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Sim" />
            <FormControlLabel value="no" control={<Radio />} label="Não" />
          </RadioGroup>
        </FormControl>
        <TextField
          id="occurrence_sumary"
          label="Conte-nos um breve relato sobre o ocorrido:"
          onChange={handleFieldChange}
          required={formState.related}
          fullWidth
          multiline
          minRows={4}
          value={formState.occurrence_sumary}
          InputLabelProps={{ shrink: true }}
          error={formErrors.occurrence_sumary}
          size="small"
          disabled={formState.related === false}
        />
        <TextField
          id="adopted_approaches"
          label="Quais foram as tratativas adotadas para a situação?"
          onChange={handleFieldChange}
          fullWidth
          multiline
          minRows={4}
          value={formState.adopted_approaches}
          InputLabelProps={{ shrink: true }}
          size="small"
          disabled={formState.related === false}
        />
        <div className={classes.buttonsContainer}>
          <Button onClick={handleOpenConfirmCleaning} variant="text">
            Limpar formulário
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Responder
          </Button>
        </div>
      </div>
      <DialogConfirm
        title="Tem certeza de que deseja limpar este formulário?"
        onConfirm={handleCleanAction}
        onCancel={handleCloseConfirmCleaning}
        open={open}
      >
        Esta ação é irreversível e não poderá ser desfeita.
      </DialogConfirm>
    </div>
  )
}

NegativeMediaForm.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default NegativeMediaForm
